import { FirestoreDataConverter } from '@angular/fire/firestore';
import { QualityError } from "./quality-error.model";

export class FileTask {

  id?: string;
  orderId: string;
  organizationId: string;
  processed: boolean;
  withError: boolean;
  inProgress: boolean;
  imported: boolean;
  message?: string;
  date: Date | null;
  endDate: Date | null;
  importFailed: number;
  qualityErrors: QualityError[];

  constructor(task?: Partial<FileTask>) {
    this.id = task?.id ?? '';
    this.orderId = task?.orderId ?? '';
    this.organizationId = task?.organizationId ?? '';
    this.processed = task?.processed ?? false;
    this.withError = task?.withError ?? false;
    this.inProgress = task?.inProgress ?? false;
    this.message = task?.message ?? '';
    this.date = task?.date ?? null;
    this.endDate = task?.endDate ?? null;
    this.importFailed = task?.importFailed ?? 0;
    this.qualityErrors = task?.qualityErrors ?? [];
  }

  static converter: FirestoreDataConverter<FileTask> = {
    toFirestore: (fileTask: FileTask) => ({
      orderId: fileTask.orderId,
      organizationId: fileTask.organizationId,
      processed: fileTask.processed,
      withError: fileTask.withError,
      inProgress: fileTask.inProgress,
      date: fileTask.date,
      endDate: fileTask.endDate,
      importFailed: fileTask.importFailed,
      qualityErrors: fileTask.qualityErrors,
    }),
    fromFirestore: (snapshot, options) => {
      const data = snapshot.data(options);
      return new FileTask({
        ...data,
        id: snapshot.id,
        date: data.date ? new Date(data.date.seconds * 1000) : null,
        endDate: data.endDate ? new Date(data.endDate.seconds * 1000) : null,
      })
    }
  };
}
